(function () {
  if (typeof preorder_message == "undefined") {
      preorder_message = null;
  }
  const shipping = {
      daysOff: $(".shipping-logic-script").data("days-off").split(","),
      nonWorkingDates: [],
      dispatch: $(".shipping-logic-script").data("dispatch"),
      cutOffTime: null,
      inStockTransportTime1Man: $(".shipping-logic-script").data("instocktransporttime1man"),
      inStockTransportTimeXDP: $(".shipping-logic-script").data("instocktransporttimexdp"),
      inStockTransportTime3PL: $(".shipping-logic-script").data("instocktransporttime3pl"),
      inStockTransportTimeCPL: $(".shipping-logic-script").data("instocktransporttimecpl"),
      inStockTransportTime2Man: $(".shipping-logic-script").data("instocktransporttime2man"),
      deliveryWindowInStock: $(".shipping-logic-script").data("deliverywindowinstock"),
      deliveryWindowPreOrder: $(".shipping-logic-script").data("deliverywindowpreorder"),   
      deliveryWindowPreOrder2Man: $(".shipping-logic-script").data("deliverywindowpreorder2man"),
      back: $(".shipping-logic-script").data("back-in-stock"),
      preOrder: preorder_message || false,
      twoManDeliveryTags: ["meta-courier:BJS"],
    isTwoManDelivery: false,
      now: new Date(),
      today: new Date(),
      
      getBy: "Get it by",
      
      init: function () {

        this.today = new Date(this.now.getFullYear(), this.now.getMonth(), this.now.getDate());
        
        if (this.preOrder) {
          this.preOrder = this.parseDate(this.preOrder);
        }
        
        if (this.daysOff !== null && this.daysOff.length > 0) {
          this.daysOff.forEach(function(dayOffValue) {
      shipping.nonWorkingDates.push(shipping.parseDate(dayOffValue));
          });
        }
    
        if (product_tags && this.twoManDeliveryTags.some((i) => product_tags.includes(i)) ) {
          this.isTwoManDelivery = true;
      }
  
        this.showInitialEstimatedDeliveryDateRange();
      },

      showInitialEstimatedDeliveryDateRange: function () {
        let earliestAvailableDate = this.today;
          if (this.preOrder && this.preOrder.getTime() > earliestAvailableDate.getTime()) {
            earliestAvailableDate = this.preOrder;
          }
          
          if (earliestAvailableDate.getTime() === this.today.getTime()) {
            // get cut off time 
            let [cutOffhours, cutOffminutes] = this.dispatch.split(":");
            // adjust today to a working date and add the cut or time
            let nextCutOffDateTime = this.addWorkingDays(this.today, 0);
            nextCutOffDateTime = new Date(nextCutOffDateTime.getFullYear(), nextCutOffDateTime.getMonth(), nextCutOffDateTime.getDate(), parseInt(cutOffhours), parseInt(cutOffminutes));
                    
            if(this.now.getTime() > nextCutOffDateTime.getTime()) {
              earliestAvailableDate = this.addWorkingDays(earliestAvailableDate, 1);
            } 
          } 
          
          let minDeliveryDate = earliestAvailableDate;
          let maxDeliveryDate = minDeliveryDate;
          if (!this.preOrder) {
            if (product_tags && product_tags.includes("meta-courier:XDP")) {
              minDeliveryDate = this.addWorkingDays(minDeliveryDate, this.inStockTransportTimeXDP);
            } else {
              if (product_tags && product_tags.includes("meta-courier:3PL")) {
                minDeliveryDate = this.addWorkingDays(minDeliveryDate, this.inStockTransportTime3PL);
              } else {
                if (product_tags && product_tags.includes("meta-courier:BJS1.CPL")) {
                  minDeliveryDate = this.addWorkingDays(minDeliveryDate, this.inStockTransportTimeCPL);
                } else {
                  if (this.isTwoManDelivery === true) {
                    minDeliveryDate = this.addWorkingDays(minDeliveryDate, this.inStockTransportTime2Man);
                  } else {
                    minDeliveryDate = this.addWorkingDays(minDeliveryDate, this.inStockTransportTime1Man);
                  }                  
                }
              }	              
            }                
            
            maxDeliveryDate = this.addWorkingDays(minDeliveryDate, this.deliveryWindowInStock);
          } else {
            minDeliveryDate = earliestAvailableDate;
            
            if (this.isTwoManDelivery === true) {
              maxDeliveryDate = this.addWorkingDays(minDeliveryDate, this.deliveryWindowPreOrder2Man);
            } else {
              maxDeliveryDate = this.addWorkingDays(minDeliveryDate, this.deliveryWindowPreOrder);
            }                      
          }
          let dateRangeString = this.dateRangeToString(minDeliveryDate, maxDeliveryDate);

          $(".top_calc_shipping").html(dateRangeString);
          $("#top_calc_shipping").html(dateRangeString);
          $(".shipping-info").show();
      },

      getAndRenderShippingMethods(clear = true) {
          const postcode = $('.check-shipping-input').val(),
                country = (postcode.substring(0, 2).toUpperCase() === 'GY') ? 'Guernsey' : (postcode.substring(0, 2).toUpperCase() === 'JE') ? 'Jersey' : (postcode.substring(0, 2).toUpperCase() === 'IM') ? 'Isle Of Man' : 'United Kingdom';
          $.ajax({
            url: "/cart/shipping_rates.json",
            dataType: 'json',
            type: 'POST',
            data: {
              shipping_address: {
                zip: postcode,
                country: country,
                province: "",
              },
            },
            error: function(jqXHR, textStatus, errorThrown) {
              shipping.renderShippingMethods([]);
            },
            success: function (data) {
                  if (data === null) {
                      setTimeout(function () {
                          shipping.getAndRenderShippingMethods(setCallback);
                      }, 150);
                  } else {
                    console.log("Shipping Rates: success");
                      shipping.renderShippingMethods(data.shipping_rates);
                      if (clear)
                          $.ajax({
                              url: "/cart/clear.js",
                              type: "POST",
                              dataType: "json",
                              success: function (params) {
                                  let oldCart = JSON.parse(localStorage.getItem("oldCart"));
                                  if (oldCart.length > 0) {
                                      Shopify.queue = oldCart;

                                      Shopify.moveAlong = function () {
                                          if (Shopify.queue.length) {
                                              var request = Shopify.queue.shift();
                                              $.ajax({
                                                  type: "POST",
                                                  url: "/cart/add.js",
                                                  dataType: "json",
                                                  data: request,
                                                  success: function success(res) {
                                                      Shopify.moveAlong();
                                                  },
                                                  error: function error() {
                                                      if (Shopify.queue.length) {
                                                          Shopify.moveAlong();
                                                      } else {
                                                          console.log("done");
                                                      }
                                                  },
                                              });
                                          } else {
                                              console.log("done");
                                          }
                                      };
                                      Shopify.moveAlong();
                                  }
                              },
                          });
                  }
              },
          });
      },

      renderShippingMethods: function (rates) {
        let rates_text = "";
        $(".shipping-info-check .shippingMethods").empty();
        rates.forEach(function (rate) {
          rates_text += `<p><div>${rate.name.split('(')[0]} £${rate.price}</div>`;              

          if (rate.delivery_range !== null) {
      rates_text += `<div class="shippingRate">${shipping.getBy} <strong id="calc_shipping"> ${shipping.renderDateRange(rate.delivery_range)}</strong></div></p>`;
          }
          
          rates_text += "<p>";
        });
        
        if(rates_text === "" ){
            rates_text = `<p class="noShippingMethods">We can't ship this item to your location.</p>`;
        }
        
        $(".shipping-info-check .loader").hide();
        $(".shipping-info-check .shippingMethods").append(rates_text);
        $(".shipping-info-check .shippingMethods").show();
      },
    
      renderDateRange: function (dates) {
        if (dates !== null) {
          let date1 = new Date(dates[0]), date2 = new Date(dates[1]);
        return this.dateRangeToString(date1, date2);
        } else {
          return "";
        }          
      },

      dateRangeToString: function(date1, date2) {
          if (date1.getMonth() === date2.getMonth() && date1.getYear() === date2.getYear()) {
            if (date1 === date2) {
              return (
                  " " +
                  this.getOrdinalSuffix(date1.getDate()) +
                  " " +
                  this.getMonthName(date1, date1.getMonth())
              );
            } else {
              return (
                  " " +
                  this.getOrdinalSuffix(date1.getDate()) +
                  " — " +
                  " " +
                  this.getOrdinalSuffix(date2.getDate()) +
                  " " +
                  this.getMonthName(false, date2.getMonth())
              );
            }
          }
          return (
              " " +
              this.getOrdinalSuffix(date1.getDate()) +
              " " +
              this.getMonthName(true, date1.getMonth()) +
              " — " +
              " " +
              this.getOrdinalSuffix(date2.getDate()) +
              " " +
              this.getMonthName(true, date2.getMonth())
          );
    },
  
      getOrdinalSuffix: function (day) {
          switch (parseInt(day)) {
              case 1:
              case 21:
              case 31:
                  return day + "<sup>st</sup>";
              case 2:
              case 22:
              case 32:
                  return day + "<sup>nd</sup>";
              case 3:
              case 23:
              case 33:
                  return day + "<sup>rd</sup>";

              default:
                  return day + "<sup>th</sup>";
          }
      },

      getMonthName: function (short, month) {
          let months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
          if (short) {
              months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
          }
          return months[month];
      },

      addDays: function (theDate, days) {
        var date = new Date(theDate.valueOf());
      date.setDate(date.getDate() + days);
        return date;
      },
  
      addWorkingDays: function(date, workingDays) {
        if(workingDays == 0) {
          // Adjust the date to next working date
          return this.addWorkingDays(this.addWorkingDays(date, 1), -1);
        }
        
        var direction = workingDays < 0 ? -1 : 1;
        var newDate = date;          
        while (workingDays != 0) {
          newDate = this.addDays(newDate, direction);

          // Saturday and Sunday is the only non-working day. Sunday date + 1 is Tuesday.
          if (newDate.getDay() !== 0 && newDate.getDay() !== 6 && !this.isInDateArray(this.nonWorkingDates, newDate))
          {
              workingDays -= direction;
          }
        }
        
        return newDate;
      },
    
      parseDate: function(dateText) {
        if (dateText.includes("-")) {
    let date_parsed = dateText.split("-"),
              month = parseInt(date_parsed[1]) - 1,
              day = parseInt(date_parsed[0]),
              year = parseInt(date_parsed[2]);
    return new Date(year, month, day);          
        } else {
    let date_parsed = dateText.split("/"),
              month = parseInt(date_parsed[1]) - 1,
              day = parseInt(date_parsed[0]),
              year = parseInt(date_parsed[2]);
    return new Date(year, month, day);                    
        }
      },
    
      isInDateArray: function(array, value) {		  
        var x = array.find(item => {return item.getTime() == value.getTime();});
        return (x !== undefined);
  },
  };

  shipping.init();
})();
